import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';
import { CardTitle, CardTitleWrap } from '@/shared/components/Card';
import FormField from '@/shared/components/form/FormField';
import CheckBox from '@/shared/components/form/CheckBox';
import DatePickers from './date-pickers/DatePicker';

export const componentMap = {
    FormField,
    CheckBox,
    DatePickers
};

const DynamicForm = ({ structure, sections = [] }) => {

    const renderField = (fieldConfig) => {
        const FieldComponent = componentMap[fieldConfig.component];
        if (!FieldComponent) {
            console.error(`Componente '${fieldConfig.component}' não encontrado no componentMap.`);
            return null;
        }

        const {
            name,
            type,
            label,
            placeholder,
            component,
            ...restProps
        } = fieldConfig;

        if (fieldConfig.component === 'CheckBox') {
            return (
                <Field
                    name={fieldConfig.name}
                    component={FieldComponent}
                    type={fieldConfig.type}
                    label={fieldConfig.label}
                    {...restProps}
                />
            );
        }

        return (
            <>
                <FormGroupLabel>{fieldConfig.label}</FormGroupLabel>
                <FormGroupField>
                    <Field
                        name={fieldConfig.name}
                        component={FieldComponent}
                        type={fieldConfig.type}
                        placeholder={fieldConfig.placeholder}
                        {...restProps}
                    />
                </FormGroupField>
            </>
        );
    };

    return sections.map((section, sectionIndex) => (
        <React.Fragment key={sectionIndex}>
            <CardTitleWrap className="mb-3 mt-1">
                <CardTitle>{section.title}</CardTitle>
            </CardTitleWrap>
            {section.rows.map(rowIndex => (
                <FormGroup key={rowIndex}>
                    <Row>
                        {structure[rowIndex].map((fieldConfig, fieldIndex) => (
                            <Col key={fieldIndex} {...fieldConfig.colProps}>
                                {renderField(fieldConfig)}
                            </Col>
                        ))}
                    </Row>
                </FormGroup>
            ))}
        </React.Fragment>
    ));
};

export default DynamicForm;